import { formatDateForReport } from './dateHelper';

export const downloadReport = (blob: Blob, name?: string) => {
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = name || `Kodiak Reports ${formatDateForReport()}.${blob.type === 'application/pdf' ? 'pdf' : 'zip'}`;
  link.click();
};
